
import { palette } from "@dev/ee-components";
import styled from "styled-components";

export const SignUpToCreatorsNewsletterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

interface SignUpToCreatorsNewsletterBoxProps {
    $isSingleColumn: boolean;
}

export const SignUpToCreatorsNewsletterBox = styled.div<SignUpToCreatorsNewsletterBoxProps>`
    border-radius: 4px;
    border: 1px solid ${palette.gray[3]};
    background: ${palette.snow[5]};
    padding: 25px 48px;
    display: grid;
    ${(props) => props.$isSingleColumn ? 'grid-template-columns: 1fr;' : 'grid-template-columns: minmax(40%, 504px) 1fr;'};
    gap: 30px;
`;

export const SignUpToCreatorsNewsletterText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SignUpToCreatorsNewsletterButtons = styled.div`
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 12px;
`;

export const SignUpToCreatorsNewsletterImages = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;

    svg {
        max-width: 100%;
    }
`;
